import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const UserModal = ({ show, onHide, onSave, user }) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    setFormData(user ? { ...user } : { name: '', email: '', role: 'L1 Maker', team: 'Retail Banking', status: 'Active', password: 'password' });
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{user ? 'Edit User' : 'Add New User'}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Full Name</Form.Label>
            <Form.Control type="text" name="name" value={formData.name || ''} onChange={handleChange} required />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email Address</Form.Label>
            <Form.Control type="email" name="email" value={formData.email || ''} onChange={handleChange} required />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Role</Form.Label>
            <Form.Select name="role" value={formData.role || 'L1 Maker'} onChange={handleChange}>
              <option value="L1 Maker">L1 Maker</option>
              <option value="L2 Checker">L2 Checker</option>
              <option value="L3 Admin">L3 Admin</option>
            </Form.Select>
          </Form.Group>
           <Form.Group className="mb-3">
            <Form.Label>Team / Group</Form.Label>
            <Form.Select name="team" value={formData.team || 'Retail Banking'} onChange={handleChange}>
              <option>Retail Banking</option>
              <option>Corporate Banking</option>
              <option>Compliance</option>
              <option>Management</option>
            </Form.Select>
          </Form.Group>
           <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select name="status" value={formData.status || 'Active'} onChange={handleChange}>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Close</Button>
          <Button variant="primary" type="submit">Save Changes</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default UserModal;